import React, { useEffect, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';

const Swal = require('sweetalert2');

const showToast = (icon, message) => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
};

function LeaveSettings() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");

    const navigate = useNavigate();

    const [leaveData, setLeaveData] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingLeave, setEditingLeave] = useState(null);

    const [editedLeaveData, setEditedLeaveData] = useState({
        leave_type: '',
        max_leave: '',
        leave_applicabledays: '',
        leave_consecutivedays: '',
        leave_status: '',
    });

    useEffect(() => {
        fetchLeaveTypes();
    }, []);

    useEffect(() => {

        let table;

        if (leaveData.length > 0) {

            setTimeout(() => {

                if ($.fn.DataTable.isDataTable('#customField')) {
                    $('#customField').DataTable().destroy();
                }

                table = $('#customField').DataTable({
                    destroy: true,
                    retrieve: true,
                });

            }, 0);
        }

        return () => {
            if ($.fn.DataTable.isDataTable('#customField')) {
                $('#customField').DataTable().destroy();
            }
        };

    }, [leaveData]);

    const fetchLeaveTypes = () => {

        axios
            .get(baseurladdress + "findallleaves", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {

                setLeaveData(
                    Array.isArray(res.data.response)
                        ? res.data.response
                        : []
                );

            })
            .catch((error) => {
                console.error("Error fetching leave types:", error);
                showToast('error', 'Failed to fetch leave details');
            });
    };

    const openEditModal = (leave) => {

        setEditingLeave(leave);

        setEditedLeaveData({
            leave_type: leave.leave_type,
            max_leave: leave.max_leave,
            leave_applicabledays: leave.leave_applicabledays,
            leave_consecutivedays: leave.leave_consecutivedays,
            leave_status: leave.leave_status,
            leave_carryforward: leave.leave_carryforward,
            leave_withoutpay: leave.leave_withoutpay,
            leave_partialpay: leave.leave_partialpay,
            leave_optional: leave.leave_optional,
            leave_compensatory: leave.leave_compensatory,
            userid: accessuserid,
            leaveid: leave.leaveid
        });

        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setEditingLeave(null);
    };

    const handleInputChange = (e) => {

        const { name, type, checked, value } = e.target;

        setEditedLeaveData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
        }));
    };

    const handleUpdateLeave = () => {
    if (!editingLeave) return;

    axios
        .put(baseurladdress + `updateleave`, editedLeaveData, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then((res) => {

            // destroy datatable before updating state
            if ($.fn.DataTable.isDataTable('#customField')) {
                $('#customField').DataTable().destroy();
            }

            // update state immediately
            const updatedData = leaveData.map((item) =>
                item.leaveid === editedLeaveData.leaveid
                    ? {
                          ...item,
                          ...editedLeaveData
                      }
                    : item
            );

            setLeaveData(updatedData);

            showToast('success', 'Leave details updated successfully');

            closeEditModal();

            // reinitialize datatable
            setTimeout(() => {
                $('#customField').DataTable({
                    destroy: true,
                    retrieve: true
                });
            }, 300);
        })
        .catch((error) => {
            console.error("Error updating leave:", error);
            showToast('error', 'Failed to update leave details');
        });
};
    function handleDeleteClick(ids) {

        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {

            if (result.isConfirmed) {

                axios
                    .post(
                        baseurladdress + `deleteleavetype/` + ids,
                        leaveData,
                        {
                            headers: {
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    )
                    .then((result) => {

                        const Data = result.data.status;

                        if (Data === "deleted") {

                            if ($.fn.DataTable.isDataTable('#customField')) {
                                $('#customField').DataTable().clear().destroy();
                            }

                            showToast('success', 'Leave Type Deleted Successfully');

                            fetchLeaveTypes();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        showToast('error', 'Delete failed');
                    });
            }
        });
    }

    return (

        <div>

            <Topnavbar />
            <Sidennav />

            <div className="content-wrap">

                <div className="main">

                    <div className="container-fluid">

                        <section id="main-content">

                            <div className="card">

                                <div
                                    className="card-header"
                                    style={{ color: "black" }}
                                >

                                    <h6 className="card-title">
                                        Leave Type Details
                                    </h6>

                                    <div className="d-flex align-items-center">

                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            onClick={() => navigate("/addleavesettings")}
                                            style={{ marginRight: '50px' }}
                                        >

                                            <span style={{ fontSize: "1.2rem" }}>
                                                <i className='fa fa-plus-circle text-success'></i>
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: "0.7rem",
                                                    color: "black",
                                                    padding: "5px"
                                                }}
                                            >
                                                Add
                                            </span>

                                        </button>

                                    </div>

                                </div>

                                <div className="card-body">

                                    <div className="col-lg-12">

                                        <div className="card">

                                            <div className="card-body">

                                                <div className="table-responsive">

                                                    <table
                                                        className="table table-bordered table-responsive-sm"
                                                        id="customField"
                                                        key={leaveData.length}
                                                    >

                                                        <thead>

                                                            <tr>
                                                                <th>Sl.No</th>
                                                                <th>Leave Title</th>
                                                                <th>Maximum Days</th>
                                                                <th>Applicable Days</th>
                                                                <th>Consecutive Days</th>
                                                                <th>Status</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </tr>

                                                        </thead>

                                                        <tbody>

                                                            {
                                                                leaveData.length > 0 ? (

                                                                    leaveData.map((item, index) => (

                                                                        <tr key={item.leaveid || index}>

                                                                            <td>{index + 1}</td>

                                                                            <td>{item.leave_type}</td>

                                                                            <td>{item.max_leave}</td>

                                                                            <td>{item.leave_applicabledays}</td>

                                                                            <td>{item.leave_consecutivedays}</td>

                                                                            <td>

                                                                                {
                                                                                    item.leave_status === 1 ? (
                                                                                        <span className="badge bg-success">
                                                                                            Active
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span className="badge bg-danger">
                                                                                            Inactive
                                                                                        </span>
                                                                                    )
                                                                                }

                                                                            </td>

                                                                            <td style={{ textAlign: "center" }}>

                                                                                <i
                                                                                    className="text-primary fa fa-edit"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => openEditModal(item)}
                                                                                ></i>

                                                                            </td>

                                                                            <td style={{ textAlign: "center" }}>

                                                                                <i
                                                                                    className="text-danger fa fa-trash"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => handleDeleteClick(item.leaveid)}
                                                                                ></i>

                                                                            </td>

                                                                        </tr>

                                                                    ))

                                                                ) : (

                                                                    <tr>

                                                                        <td
                                                                            colSpan="8"
                                                                            className="text-center"
                                                                        >
                                                                            No data found
                                                                        </td>

                                                                    </tr>

                                                                )
                                                            }

                                                        </tbody>

                                                    </table>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </section>

                    </div>

                </div>

            </div>

            {
                isEditModalOpen && editingLeave && (

                    <div
                        className="modal fade show"
                        style={{
                            display: 'block',
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        }}
                    >

                        <div className="modal-dialog modal-lg">

                            <div className="modal-content">

                                <div className="modal-header">

                                    <h4 className="modal-title">
                                        Edit Leave Type
                                    </h4>

                                    <button
                                        type="button"
                                        className="close"
                                        onClick={closeEditModal}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>

                                </div>

                                <div className="modal-body">

                                    <form>

                                        <div className="row">

                                            <div className="col-md-6">

                                                <div className="form-group">

                                                    <h6>Leave Title</h6>

                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="leave_type"
                                                        value={editedLeaveData.leave_type}
                                                        onChange={handleInputChange}
                                                    />

                                                </div>

                                                <div className="form-group">

                                                    <h6>Maximum Days</h6>

                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="max_leave"
                                                        value={editedLeaveData.max_leave}
                                                        onChange={handleInputChange}
                                                    />

                                                </div>

                                            </div>

                                            <div className="col-md-6">

                                                <div className="form-group">

                                                    <h6>Applicable Days</h6>

                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="leave_applicabledays"
                                                        value={editedLeaveData.leave_applicabledays}
                                                        onChange={handleInputChange}
                                                    />

                                                </div>

                                                <div className="form-group">

                                                    <h6>Consecutive Days</h6>

                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="leave_consecutivedays"
                                                        value={editedLeaveData.leave_consecutivedays}
                                                        onChange={handleInputChange}
                                                    />

                                                </div>

                                            </div>

                                        </div>

                                    </form>

                                </div>

                                <div className="modal-footer">

                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeEditModal}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleUpdateLeave}
                                    >
                                        Save Changes
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>
    );
}

export default LeaveSettings;